/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function LinkBroken({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M6 .4a.6.6 0 0 1 .6.6v1.5a.6.6 0 0 1-1.2 0V1A.6.6 0 0 1 6 .4M1.576 1.576a.6.6 0 0 1 .848 0l1.25 1.25a.6.6 0 0 1-.848.848l-1.25-1.25a.6.6 0 0 1 0-.848m10.95 1.899a2.4 2.4 0 0 0-3.395 0L7.717 4.889a.6.6 0 1 1-.848-.849l1.414-1.414a3.6 3.6 0 1 1 5.091 5.091L11.96 9.131a.6.6 0 1 1-.849-.848l1.414-1.414a2.4 2.4 0 0 0 0-3.394m-1.273 1.272a.6.6 0 0 1 0 .849l-5.657 5.657a.6.6 0 0 1-.849-.849l5.657-5.657a.6.6 0 0 1 .849 0M.4 6a.6.6 0 0 1 .6-.6h1.5a.6.6 0 0 1 0 1.2H1A.6.6 0 0 1 .4 6m4.489.869a.6.6 0 0 1 0 .848L3.475 9.131a2.4 2.4 0 0 0 3.394 3.394l1.414-1.414a.6.6 0 0 1 .848.849l-1.414 1.414a3.6 3.6 0 1 1-5.091-5.091L4.04 6.869a.6.6 0 0 1 .849 0M12.9 10a.6.6 0 0 1 .6-.6H15a.6.6 0 1 1 0 1.2h-1.5a.6.6 0 0 1-.6-.6m-.574 2.326a.6.6 0 0 1 .848 0l1.25 1.25a.6.6 0 0 1-.848.848l-1.25-1.25a.6.6 0 0 1 0-.848M10 12.9a.6.6 0 0 1 .6.6V15a.6.6 0 1 1-1.2 0v-1.5a.6.6 0 0 1 .6-.6" clipRule="evenodd" /></svg>;
}
;